import { PROCESSOR_TYPE_OPTIONS } from '@/app/processors/create/processor-metadata';

export interface SetupPaymentSummary {
  processorName: string;
  processorLogo: string;
}

export function buildSetupPaymentSummaryFromOption(
  processorName: string,
  processorLogo: string,
): SetupPaymentSummary {
  return {
    processorName: processorName.trim(),
    processorLogo,
  };
}

export function buildSetupPaymentSummaryFromType(processorType: string): SetupPaymentSummary | null {
  const option = PROCESSOR_TYPE_OPTIONS.find((entry) => entry.value === processorType);
  if (!option) return null;

  return buildSetupPaymentSummaryFromOption(option.label, option.logo);
}

export function buildSetupPaymentSummaryFromProcessorRecord(
  name: string | null | undefined,
  type: string | null | undefined,
): SetupPaymentSummary | null {
  const fromType = type ? buildSetupPaymentSummaryFromType(type) : null;
  const trimmedName = name?.trim() ?? '';

  if (fromType && trimmedName) {
    return { ...fromType, processorName: trimmedName };
  }

  if (fromType) return fromType;

  if (trimmedName) {
    return { processorName: trimmedName, processorLogo: '' };
  }

  return null;
}

export interface SetupPaymentConfiguredResult {
  processorId: string;
  paymentFlowId: string;
  paymentSnapshot: SetupPaymentSummary;
}

/** Payment currently live on the store (DB truth): selectedPaymentFlowId → flow → first usable processor. */
export interface SetupActivePayment {
  flowId: string;
  processorId: string;
  processorType: string;
  /** Single-processor flow (setup-grade) — safe to update in place when switching. */
  isSoloFlow: boolean;
  summary: SetupPaymentSummary;
}
